import AuthUser from "../services/AuthUser";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export { PrivateRoute };

function PrivateRoute({ children }) {
  const { getToken } = AuthUser();

  if (!getToken()) {
    // not logged in so redirect to login page with the return url
    return <Navigate to="/" />;
  }

  // authorized so return child components
  return children;
}

export default PrivateRoute;
